import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "@rocketseat/unform";
import {
	Container,
	Content,
	FormGroupInput,
	FormGroupLine,
	Group,
	SubmitButtom,
	InputText,
	Label,
	Title,
	PasswordEye,
	MessageError,
	ContainerRequirements,
} from "./styles";
import { changePasswordAfterValidate } from "../../store/modules/recoverPassword/actions";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import alertIcon from "../../assets/alert-outline.svg";
import checkIcon from "../../assets/check-icon.svg";
import { CircularProgress } from "@material-ui/core";

export default function ChangePassword(props) {
	const { token, loading } = useSelector((state) => state.recoverPassword);
	const [hidePassword, setHidePassword] = useState(true);
	const [passwordConfirmShown, setPasswordConfirmShown] = useState(true);
	// let flowPage = {
	//   param: props.sendInfos.param,
	//   token: props.sendInfos.token,
	//   cpf: props.sendInfos.cpf,
	//   recoveryInfoType: props.sendInfos.recoveryInfoType,
	//   recoveryInfo: props.sendInfos.recoveryInfo
	// }

	const dispatch = useDispatch();
	const [novaSenha, setNovaSenha] = useState("");
	const [password, setPassword] = useState("");

	const [lowerCase, setLowerCase] = useState(false);
	const [upperCase, setUpperCase] = useState(false);
	const [number, setNumber] = useState(false);
	const [minimum, setMinimum] = useState(false);
	const [caracterSpecial, setCaracterSpecial] = useState(false);
	const [sequentialPassword, setSequentialPassword] = useState(false);

	const [errors, setErrors] = useState({
		novaSenha: {
			value: true,
			read: false,
		},
		password: {
			value: true,
			read: false,
		},
	});
	const [passwordDifferent, setPasswordDifferent] = useState(false);
	const [disableButton, setDisableButton] = useState(true);

	useEffect(() => {
		setDisableButton(
			!(
				minimum &&
				number &&
				lowerCase &&
				upperCase &&
				caracterSpecial &&
				password &&
				sequentialPassword &&
				!passwordDifferent
			)
		);
	}, [minimum, number, lowerCase, upperCase, caracterSpecial, password, sequentialPassword, passwordDifferent]);

	function validaSenha(password) {
		setMinimum(password.length >= 8);
		setNumber(/\d/.test(password));
		setLowerCase(/[a-z]/.test(password));
		setUpperCase(/[A-Z]/.test(password));
		setCaracterSpecial(/(?=.*\W)/.test(password));
		setSequentialPassword(/^(?=.*\d)(?!.*(?:012|123|234|345|456|567|678|789|890))/.test(password));
	}

	function handleChange(event) {
		event.preventDefault();
		const { name, value } = event.target;
		let actions = {
			novaSenha: () => {
				errors.novaSenha.value = !value.length ? true : false;
				errors.novaSenha.read = true;
				setNovaSenha(value);
				validaSenha(event.target.value);
			},
			password: () => {
				errors.password.value = !value.length ? true : false;
				errors.password.read = true;
				setPassword(value);
			},
		};

		if (Object.keys(actions).includes(name) !== -1) {
			actions[name]();
		}

		setErrors(errors);
		setPasswordDifferent(false);
	}

	function submitPassword() {
		validingPassword(password);
		if (!passwordDifferent) dispatch(changePasswordAfterValidate(token, novaSenha, password));

		if (sessionStorage.getItem("educa")) {
			setRefEduca(window.location.href);
			sessionStorage.removeItem("educa");
			sessionStorage.removeItem("isBeta");
		}
	}

	const validingPassword = (param) => {
		setPasswordDifferent(novaSenha !== param);
	};

	const validateBothPasswords = (newPass, confirmNewPass) => {
		setPasswordDifferent(newPass !== confirmNewPass);
	};

	function setRefEduca(ref) {
		let isBeta = sessionStorage.getItem("isBeta");
		ref = ref.replace("/onboard/welcome-register", "");
		if (!ref.includes("alpha") && ref.includes("portal.trademap")) {
			ref = ref.replace("portal", "portal-educa");
		}
		if (ref.includes("alpha") && isBeta == null) {
			ref = ref.replace("alpha", "educa");
		}
		if (isBeta) {
			ref = "https://beta-portal-educa.trademapdev.com.br/login";
		}
		window.location.href = ref;
	}

	return (
		<Container>
			<Content>
				<Title>Crie sua nova senha {":)"}</Title>
				<Form onSubmit={() => {}}>
					<FormGroupInput>
						<Label>Nova senha</Label>
						<div className="container-password">
							<InputText
								error={{ value: false }}
								type={
									hidePassword
										? "password"
										: "text"
								}
								name="novaSenha"
								id="novaSenha"
								value={novaSenha}
								onChange={(e) => {
									handleChange(e);
									if (password) {
										validateBothPasswords(
											e.target
												.value,
											password
										);
									}
								}}
							/>
							<PasswordEye
								error={false}
								onClick={() =>
									setHidePassword(!hidePassword)
								}
							>
								{hidePassword ? (
									<Visibility width={18} />
								) : (
									<VisibilityOff width={18} />
								)}
							</PasswordEye>
						</div>
					</FormGroupInput>
					<ContainerRequirements>
						<FormGroupLine>
							<Group>
								<img
									src={
										minimum
											? checkIcon
											: alertIcon
									}
									alt="Check Icon"
								/>
								<span>8 caracteres</span>
							</Group>
						</FormGroupLine>
						<FormGroupLine>
							<Group>
								<img
									src={
										lowerCase
											? checkIcon
											: alertIcon
									}
									alt="Check Icon"
								/>
								<span>1 letra minúscula</span>
							</Group>
						</FormGroupLine>
						<FormGroupLine>
							<Group>
								<img
									src={
										upperCase
											? checkIcon
											: alertIcon
									}
									alt="Check Icon"
								/>
								<span>1 letra maiúscula</span>
							</Group>
						</FormGroupLine>
						<FormGroupLine>
							<Group>
								<img
									src={
										number
											? checkIcon
											: alertIcon
									}
									alt="Check Icon"
								/>
								<span>1 número</span>
							</Group>
						</FormGroupLine>
						<FormGroupLine>
							<Group>
								<img
									src={
										caracterSpecial
											? checkIcon
											: alertIcon
									}
									alt="Check Icon"
								/>
								<span>1 caracter especial</span>
							</Group>
						</FormGroupLine>
						<FormGroupLine>
							<Group>
								<img
									src={
										sequentialPassword
											? checkIcon
											: alertIcon
									}
									alt="Check Icon"
								/>
								<span>
									A senha não pode ter sequência
									númerica. Ex: 123, 234.
								</span>
							</Group>
						</FormGroupLine>
					</ContainerRequirements>
					<FormGroupInput>
						<Label>Confirme sua nova senha</Label>
						<div className="container-password">
							<InputText
								error={{ value: passwordDifferent }}
								type={
									passwordConfirmShown
										? "password"
										: "text"
								}
								name="password"
								id="password"
								value={password}
								onChange={(e) => {
									handleChange(e);
									validingPassword(
										e.target.value
									);
								}}
								onFocus={(e) => {
									e.target.removeAttribute(
										"readonly"
									);
								}}
							></InputText>
							<PasswordEye
								error={false}
								onClick={() =>
									setPasswordConfirmShown(
										!passwordConfirmShown
									)
								}
							>
								{passwordConfirmShown ? (
									<Visibility width={18} />
								) : (
									<VisibilityOff width={18} />
								)}
							</PasswordEye>
						</div>
						{passwordDifferent ? (
							<MessageError>
								As senhas precisam ser iguais
							</MessageError>
						) : null}
					</FormGroupInput>
					<SubmitButtom
						onClick={() => submitPassword()}
						disabled={disableButton}
					>
						{loading ? (
							<CircularProgress
								style={{
									width: "20px",
									height: "20px",
									color: "#13141B",
								}}
							/>
						) : (
							"Salvar nova senha"
						)}
					</SubmitButtom>
				</Form>
			</Content>
		</Container>
	);
}
